"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var r = n(e),
    _o = function o() {
  return (_o = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var o in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  }).apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function a(e, t, n) {
  if (n || 2 === arguments.length) for (var r, o = 0, a = t.length; o < a; o++) {
    !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  }
  return e.concat(r || t);
}

var c = new RegExp(" "),
    u = function u(e) {
  var t = e.wholeWords ? " " + e.keyword + " " : e.keyword,
      n = e.matchCase ? "g" : "gi";
  return new RegExp(t, n);
},
    i = function i(e, t, n) {
  return e instanceof RegExp ? e : "string" == typeof e ? "" === e ? c : u({
    keyword: e,
    matchCase: t || !1,
    wholeWords: n || !1
  }) : (void 0 !== t && (e.matchCase = t), void 0 !== n && (e.wholeWords = n), u(e));
},
    s = function s(e) {
  var t,
      n = function (e) {
    var t = r.useRef(e.get("doc")),
        n = function n(e) {
      t.current = e;
    };

    return r.useEffect(function () {
      return e.subscribe("doc", n), function () {
        e.unsubscribe("doc", n);
      };
    }, []), t;
  }(e),
      o = r.useState([]),
      a = o[0],
      u = o[1],
      s = r.useState([]),
      l = s[0],
      h = s[1],
      f = r.useState(0),
      d = f[0],
      p = f[1],
      m = r.useState(!1),
      g = m[0],
      v = m[1],
      x = r.useRef([]),
      y = r.useState(!1),
      E = y[0],
      w = y[1],
      b = function b(e) {
    if (0 === a.length || 0 === l.length) return null;
    var t = Math.max(1, Math.min(l.length, e));
    return p(t), I(l[t - 1]);
  },
      C = function C(e) {
    return u("" === e ? [] : [e]);
  },
      I = function I(t) {
    var n = e.get("jumpToPage");
    return n && n(t.pageIndex), e.update("matchPosition", {
      matchIndex: t.matchIndex,
      pageIndex: t.pageIndex
    }), t;
  },
      S = function S(t, r, o) {
    var a = t.map(function (e) {
      return i(e, r, o);
    });
    return e.update("keyword", a), p(0), h([]), new Promise(function (e, t) {
      (0 === x.current.length ? function () {
        var e = n.current;
        if (!e) return Promise.resolve([]);
        var t = Array(e.numPages).fill(0).map(function (t, n) {
          return e.getPage(n + 1).then(function (e) {
            return e.getTextContent();
          }).then(function (e) {
            var t = e.items.map(function (e) {
              return e.str || "";
            }).join("");
            return Promise.resolve({
              pageContent: t,
              pageIndex: n
            });
          });
        });
        return Promise.all(t).then(function (e) {
          return e.sort(function (e, t) {
            return e.pageIndex - t.pageIndex;
          }), Promise.resolve(e.map(function (e) {
            return e.pageContent;
          }));
        });
      }().then(function (e) {
        return x.current = e, Promise.resolve(e);
      }) : Promise.resolve(x.current)).then(function (t) {
        var n = [];
        t.forEach(function (e, t) {
          a.forEach(function (r) {
            for (var o, a = 0; null !== (o = r.exec(e));) {
              n.push({
                keyword: r,
                matchIndex: a,
                pageIndex: t,
                pageText: e,
                startIndex: o.index,
                endIndex: r.lastIndex
              }), a++;
            }
          });
        }), h(n), n.length > 0 && (p(1), I(n[0])), e(n);
      });
    });
  };

  return r.useEffect(function () {
    x.current = [];
  }, [n.current]), {
    clearKeyword: function clearKeyword() {
      0 !== a.length && (e.update("keyword", [c]), C(""), p(0), h([]), v(!1), w(!1));
    },
    changeMatchCase: function changeMatchCase(e) {
      v(e), a.length > 0 && S(a, e, E);
    },
    changeWholeWords: function changeWholeWords(e) {
      w(e), a.length > 0 && S(a, g, e);
    },
    currentMatch: d,
    jumpToMatch: b,
    jumpToNextMatch: function jumpToNextMatch() {
      return b(d + 1);
    },
    jumpToPreviousMatch: function jumpToPreviousMatch() {
      return b(d - 1);
    },
    keywords: a,
    matchCase: g,
    numberOfMatches: l.length,
    wholeWords: E,
    search: function search() {
      return S(a, g, E);
    },
    searchFor: S,
    setKeywords: u,
    keyword: 0 === a.length ? "" : (t = a[0], t instanceof RegExp ? t.source : "string" == typeof t ? t : t.keyword),
    setKeyword: C
  };
},
    l = function l(e) {
  var t = e.children,
      n = e.store,
      r = s(n);
  return t(_o({}, r));
},
    h = function h() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M0.541,5.627L11.666,18.2c0.183,0.207,0.499,0.226,0.706,0.043c0.015-0.014,0.03-0.028,0.043-0.043\n            L23.541,5.627"
  }));
},
    f = function f() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M23.535,18.373L12.409,5.8c-0.183-0.207-0.499-0.226-0.706-0.043C11.688,5.77,11.674,5.785,11.66,5.8\n            L0.535,18.373"
  }));
},
    d = {
  left: 0,
  top: 8
},
    p = function p(e) {
  var n = e.store,
      o = e.onToggle,
      a = r.useContext(t.LocalizationContext),
      c = r.useState(!1),
      u = c[0],
      i = c[1],
      l = s(n),
      p = l.clearKeyword,
      m = l.changeMatchCase,
      g = l.changeWholeWords,
      v = l.currentMatch,
      x = l.jumpToNextMatch,
      y = l.jumpToPreviousMatch,
      E = l.keyword,
      w = l.matchCase,
      b = l.numberOfMatches,
      C = l.wholeWords,
      I = l.search,
      S = l.setKeyword,
      k = a && a.search ? a.search.enterToSearch : "Enter to search",
      _ = a && a.search ? a.search.previousMatch : "Previous match",
      P = a && a.search ? a.search.nextMatch : "Next match";

  return r.createElement("div", {
    className: "rpv-search__popover"
  }, r.createElement("div", {
    className: "rpv-search__popover-input-counter"
  }, r.createElement(t.TextBox, {
    ariaLabel: k,
    placeholder: k,
    type: "text",
    value: E,
    onChange: S,
    onKeyDown: function onKeyDown(e) {
      "Enter" === e.key && E && (i(!0), I().then(function (e) {
        return i(!1);
      }));
    }
  }), r.createElement("div", {
    className: "rpv-search__popover-counter"
  }, u && r.createElement(t.Spinner, {
    size: "1rem"
  }), !u && r.createElement("span", null, v, "/", b))), r.createElement("label", {
    className: "rpv-search__popover-label"
  }, r.createElement("input", {
    className: "rpv-search__popover-label-checkbox",
    checked: w,
    type: "checkbox",
    onChange: function onChange(e) {
      m(e.target.checked);
    }
  }), " ", a && a.search ? a.search.matchCase : "Match case"), r.createElement("label", {
    className: "rpv-search__popover-label"
  }, r.createElement("input", {
    className: "rpv-search__popover-label-checkbox",
    checked: C,
    type: "checkbox",
    onChange: function onChange(e) {
      g(e.target.checked);
    }
  }), " ", a && a.search ? a.search.wholeWords : "Whole words"), r.createElement("div", {
    className: "rpv-search__popover-footer"
  }, r.createElement("div", {
    className: "rpv-search__popover-footer-item"
  }, r.createElement(t.Tooltip, {
    ariaControlsSuffix: "search-previous-match",
    position: t.Position.BottomCenter,
    target: r.createElement(t.MinimalButton, {
      ariaLabel: _,
      isDisabled: v <= 1,
      onClick: y
    }, r.createElement(f, null)),
    content: function content() {
      return _;
    },
    offset: d
  })), r.createElement("div", {
    className: "rpv-search__popover-footer-item"
  }, r.createElement(t.Tooltip, {
    ariaControlsSuffix: "search-next-match",
    position: t.Position.BottomCenter,
    target: r.createElement(t.MinimalButton, {
      ariaLabel: P,
      isDisabled: v > b - 1,
      onClick: x
    }, r.createElement(h, null)),
    content: function content() {
      return P;
    },
    offset: d
  })), r.createElement("div", {
    className: "rpv-search__popover-footer-button"
  }, r.createElement(t.Button, {
    onClick: function onClick() {
      o(), p();
    }
  }, a && a.search ? a.search.close : "Close"))));
},
    m = function m() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M10.5,0.5c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.5,10.5,0.5z\n            M23.5,23.5\n            l-5.929-5.929"
  }));
},
    g = function g(e) {
  var n = e.children,
      o = e.onClick,
      a = r.useContext(t.LocalizationContext),
      c = a && a.search ? a.search.search : "Search";
  return n({
    icon: r.createElement(m, null),
    label: c,
    onClick: o
  });
},
    v = {
  left: 0,
  top: 8
},
    x = function x(e) {
  var n = e.onClick;
  return r.createElement(g, {
    onClick: n
  }, function (e) {
    return r.createElement(t.Tooltip, {
      ariaControlsSuffix: "search-popover",
      position: t.Position.BottomCenter,
      target: r.createElement(t.MinimalButton, {
        ariaLabel: e.label,
        onClick: n
      }, e.icon),
      content: function content() {
        return e.label;
      },
      offset: v
    });
  });
},
    y = {
  left: 0,
  top: 8
},
    E = function E(e) {
  var n = e.children,
      a = e.store,
      c = n || function (e) {
    return r.createElement(x, _o({}, e));
  };

  return r.createElement(t.Popover, {
    ariaControlsSuffix: "search",
    position: t.Position.BottomLeft,
    target: function target(e) {
      return c({
        onClick: e
      });
    },
    content: function content(e) {
      return r.createElement(p, {
        store: a,
        onToggle: e
      });
    },
    offset: y,
    closeOnClickOutside: !1,
    closeOnEscape: !0
  });
},
    w = function w(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
},
    b = function b(e) {
  var t = e.parentNode;

  if (t) {
    var n = document.createRange();
    n.selectNodeContents(e), function (e, t) {
      w(e);
      var n = t.parentNode;
      n && n.insertBefore(e, t), w(t);
    }(n.extractContents(), e), t.normalize();
  }
},
    C = function C(e) {
  var n = e.pageIndex,
      o = e.store,
      u = e.onHighlightKeyword,
      i = r.useState({
    matchIndex: -1,
    pageIndex: -1
  }),
      s = i[0],
      l = i[1],
      h = r.useState([c]),
      f = h[0],
      d = h[1],
      p = r.useState({
    pageIndex: n,
    scale: 1,
    status: t.LayerRenderStatus.PreRender
  }),
      m = p[0],
      g = p[1],
      v = r.useRef(null),
      x = r.useRef([]),
      y = function y(e) {
    for (var t = e.querySelectorAll("span.rpv-search__highlight"), n = t.length, r = 0; r < n; r++) {
      t[r].parentElement.removeChild(t[r]);
    }
  },
      E = function E(e) {
    var t = x.current;

    if (0 !== t.length) {
      var n = [].slice.call(e.querySelectorAll(".rpv-core__text-layer-text")),
          r = t.map(function (e) {
        return e.char;
      }).join("");
      f.forEach(function (o) {
        if (o.source.trim()) {
          for (var c, i = -1 === o.flags.indexOf("g") ? new RegExp(o, o.flags + "g") : o, s = []; null !== (c = i.exec(r));) {
            s.push({
              keyword: i,
              startIndex: c.index,
              endIndex: i.lastIndex
            });
          }

          s.map(function (e) {
            return {
              keyword: e.keyword,
              indexes: t.slice(e.startIndex, e.endIndex)
            };
          }).forEach(function (t) {
            var r = t.indexes.reduce(function (e, t) {
              return e[t.spanIndex] = a(a([], e[t.spanIndex] || []), [t]), e;
            }, {});
            Object.values(r).forEach(function (r) {
              !function (e, t, n, r) {
                var o = document.createRange(),
                    a = n.firstChild;

                if (a) {
                  var c = r[0].charIndexInSpan,
                      i = 1 === r.length ? c : r[r.length - 1].charIndexInSpan;
                  o.setStart(a, c), o.setEnd(a, i + 1);
                  var s = document.createElement("span");
                  o.surroundContents(s);
                  var l = s.getBoundingClientRect(),
                      h = t.getBoundingClientRect(),
                      f = document.createElement("span");
                  t.appendChild(f), f.style.left = 100 * (l.left - h.left) / h.width + "%", f.style.top = 100 * (l.top - h.top) / h.height + "%", f.style.width = 100 * l.width / h.width + "%", f.style.height = 100 * l.height / h.height + "%", f.classList.add("rpv-search__highlight"), f.setAttribute("title", e.source.trim()), b(s), u && u({
                    highlightEle: f,
                    keyword: e
                  });
                }
              }(t.keyword, e, n[r[0].spanIndex], r);
            });
          });
        }
      });
    }
  },
      w = function w(e) {
    e && e.length > 0 && d(e);
  },
      C = function C(e) {
    return l(e);
  },
      I = function I(e) {
    if (e.has(n)) {
      var t = e.get(n);
      t && g({
        ele: t.ele,
        pageIndex: n,
        scale: t.scale,
        status: t.status
      });
    }
  },
      S = function S() {
    return 0 === f.length || 1 === f.length && "" === f[0].source.trim();
  };

  r.useEffect(function () {
    if (!S() && m.status === t.LayerRenderStatus.DidRender && !x.current.length) {
      var e = m.ele,
          n = [].slice.call(e.querySelectorAll(".rpv-core__text-layer-text")).map(function (e) {
        return e.textContent;
      }).reduce(function (e, t, n) {
        return e.concat(t.split("").map(function (e, t) {
          return {
            char: e,
            charIndexInSpan: t,
            spanIndex: n
          };
        }));
      }, [{
        char: "",
        charIndexInSpan: 0,
        spanIndex: 0
      }]).slice(1);
      x.current = n;
    }
  }, [f, m.status]), r.useEffect(function () {
    if (!S() && m.ele && m.status === t.LayerRenderStatus.DidRender) {
      var e = m.ele;
      y(e), E(e), k();
    }
  }, [f, s, m.status, x.current]), r.useEffect(function () {
    S() && m.ele && m.status === t.LayerRenderStatus.DidRender && y(m.ele);
  }, [f, m.status]);

  var k = function k() {
    if (s.pageIndex === n && m.ele && m.status === t.LayerRenderStatus.DidRender) {
      var e = m.ele,
          r = e.querySelectorAll(".rpv-search__highlight");

      if (s.matchIndex < r.length) {
        var a = r[s.matchIndex],
            c = function (e, t) {
          for (var n = e.offsetTop, r = e.offsetLeft, o = e.parentElement; o && o !== t;) {
            n += o.offsetTop, r += o.offsetLeft, o = o.parentElement;
          }

          return {
            left: r,
            top: n
          };
        }(a, e),
            u = c.left,
            i = c.top,
            l = o.get("jumpToDestination");

        l && (l(n, (e.getBoundingClientRect().height - i) / m.scale, u / m.scale, m.scale), v.current && v.current.classList.remove("rpv-search__highlight--current"), v.current = a, a.classList.add("rpv-search__highlight--current"));
      }
    }
  };

  return r.useEffect(function () {
    return o.subscribe("keyword", w), o.subscribe("matchPosition", C), o.subscribe("renderStatus", I), function () {
      o.unsubscribe("keyword", w), o.unsubscribe("matchPosition", C), o.unsubscribe("renderStatus", I);
    };
  }, []), r.createElement(r.Fragment, null);
};

exports.NextIcon = h, exports.PreviousIcon = f, exports.SearchIcon = m, exports.searchPlugin = function (e) {
  var n = r.useMemo(function () {
    return e && e.onHighlightKeyword ? e.onHighlightKeyword : function () {};
  }, []),
      a = r.useMemo(function () {
    return t.createStore({
      renderStatus: new Map()
    });
  }, []),
      u = s(a),
      h = u.clearKeyword,
      f = u.jumpToMatch,
      d = u.jumpToNextMatch,
      p = u.jumpToPreviousMatch,
      m = u.searchFor,
      g = u.setKeywords,
      v = function v(e) {
    return r.createElement(E, _o({}, e, {
      store: a
    }));
  };

  return {
    install: function install(t) {
      var n = e && e.keyword ? function (e) {
        return Array.isArray(e) ? e.map(function (e) {
          return i(e);
        }) : [i(e)];
      }(e.keyword) : [c];
      a.update("jumpToDestination", t.jumpToDestination), a.update("jumpToPage", t.jumpToPage), a.update("keyword", n);
    },
    renderViewer: function renderViewer(e) {
      var t = e.slot;
      return t.subSlot && (t.subSlot.children = r.createElement(r.Fragment, null, Array(e.doc.numPages).fill(0).map(function (e, t) {
        return r.createElement(C, {
          key: t,
          pageIndex: t,
          store: a,
          onHighlightKeyword: n
        });
      }), t.subSlot.children)), t;
    },
    uninstall: function uninstall(e) {
      var t = a.get("renderStatus");
      t && t.clear();
    },
    onDocumentLoad: function onDocumentLoad(e) {
      a.update("doc", e.doc);
    },
    onTextLayerRender: function onTextLayerRender(e) {
      var t = a.get("renderStatus");
      t && (t = t.set(e.pageIndex, e), a.update("renderStatus", t));
    },
    Search: function Search(e) {
      return r.createElement(l, _o({}, e, {
        store: a
      }));
    },
    ShowSearchPopover: v,
    ShowSearchPopoverButton: function ShowSearchPopoverButton() {
      return r.createElement(v, null, function (e) {
        return r.createElement(x, _o({}, e));
      });
    },
    clearHighlights: function clearHighlights() {
      h();
    },
    highlight: function highlight(e) {
      var t = Array.isArray(e) ? e : [e];
      return g(t), m(t);
    },
    jumpToMatch: f,
    jumpToNextMatch: d,
    jumpToPreviousMatch: p
  };
};